/**
 * CORE-1401, возврат QA 23.10 (замечание от 08.10 и 16.10) — что видит человек
 * после «Не сейчас» там, где уйти некуда.
 *
 * На телефоне «Не сейчас» возвращает к списку чатов, в шторке приложения —
 * сворачивает её. На десктопе и в виджете веба кнопка не делала ничего
 * видимого: отказ уходил на сервер, а на экране оставался тот же гейт, и
 * нажатие выглядело сломанным. Здесь итог назван словами: чат закрыт, ИИ-сервису
 * ничего не уходит, остальная платформа работает. Вернуться к условиям — одно
 * нажатие, потому что «не сейчас» — это не «никогда».
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';

import { Button, Typography } from '../ui';
import { useTheme } from '../../context/ThemeContext';
import { useI18n } from '../../i18n';

export const AiConsentDeclined: React.FC<{ onReadAgain: () => void }> = ({ onReadAgain }) => {
  const { colors } = useTheme();
  const { t } = useI18n('chats');

  return (
    <View style={[styles.wrap, { backgroundColor: colors.backgroundAlt }]} testID="aiConsentDeclined">
      <View style={styles.body}>
        <View style={[styles.iconCircle, { backgroundColor: `${colors.solar}1F` }]}>
          <Ionicons name="pause-circle-outline" size={26} color={colors.solar} />
        </View>
        <Typography variant="h4" style={[styles.title, { color: colors.textPrimary }]} accessibilityLiveRegion="polite">
          {t('aiConsentDeclined.title')}
        </Typography>
        <Typography variant="body" style={[styles.text, { color: colors.textSecondary }]}>
          {t('aiConsentDeclined.body')}
        </Typography>
        <Button variant="outline" onPress={onReadAgain} testID="aiConsentDeclinedReadAgain" style={styles.btn}>
          {t('aiConsentDeclined.readAgain')}
        </Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { flex: 1, justifyContent: 'center' },
  body: {
    alignItems: 'center',
    paddingHorizontal: 28,
    paddingVertical: 32,
    maxWidth: 480,
    width: '100%',
    alignSelf: 'center',
    gap: 12,
  },
  iconCircle: {
    width: 52,
    height: 52,
    borderRadius: 26,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 4,
  },
  title: { textAlign: 'center' },
  text: { textAlign: 'center', lineHeight: 22 },
  btn: { marginTop: 8, minWidth: 220, borderRadius: 14 },
});
